export function useSetCookie(name: string, value: string, days: number) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString()
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expires}; path=/`
}

export function useGetCookie(name: string): string | undefined {
  const encodedName = encodeURIComponent(name) + "=";
  const cookie = document.cookie
    .split("; ")
    .find(row => row.startsWith(encodedName));

  return cookie ? decodeURIComponent(cookie.split("=")[1]) : undefined;
}